import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ContentViewModel } from '../carousel-item/content-view.model';

@Injectable()
export abstract class AbstractMyListButtonService {
  public abstract currentLoadingAssetGuid: string;
  public abstract isUserLoggedIn$: Observable<boolean>;

  public abstract isLoading$(guid: string): Observable<boolean>;
  public abstract isAddedToMyList$(content: ContentViewModel): Observable<boolean>;
  public abstract addToMyList(content: ContentViewModel): void;
  public abstract removeFromMyList(content: ContentViewModel): void;
}
